export default __webpack_public_path__ + "static/signiantLogo-651f1bf0cd1a99289e5cba41b1e74ea9.svg";